import React, { useState } from 'react';
import { createChannel } from '../services/channelService';
import './CreateChannelForm.css';

const CreateChannelForm = ({ currentUser, onChannelCreated, onCancel }) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!name.trim()) {
      setError('Channel name is required');
      return;
    }

    if (name.trim().length < 2) {
      setError('Channel name must be at least 2 characters');
      return;
    }

    if (name.trim().length > 50) {
      setError('Channel name must be less than 50 characters');
      return;
    }

    setLoading(true);
    setError('');

    try {
      await createChannel(name, description, currentUser);
      setName('');
      setDescription('');
      onChannelCreated();
    } catch (error) {
      setError('Failed to create channel. Please try again.');
      console.error('Error creating channel:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="create-channel-form-overlay">
      <div className="create-channel-form">
        <div className="form-header">
          <h3>Create New Channel</h3>
          <button 
            className="close-button"
            onClick={onCancel}
            disabled={loading}
          >
            ×
          </button>
        </div>

        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="channel-name">Channel Name *</label>
            <input
              id="channel-name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g. general, announcements, random"
              disabled={loading}
              maxLength={50}
            />
          </div>

          <div className="form-group">
            <label htmlFor="channel-description">Description</label>
            <textarea
              id="channel-description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="What's this channel about? (optional)"
              disabled={loading}
              maxLength={200}
              rows={3}
            />
          </div>

          <div className="form-actions">
            <button 
              type="button" 
              className="cancel-button"
              onClick={onCancel}
              disabled={loading}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="create-button"
              disabled={loading || !name.trim()}
            >
              {loading ? 'Creating...' : 'Create Channel'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateChannelForm;